var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('client-search',{attrs:{"manual-filters":_vm.AffiliateClientsParam(),"show-guests-toggle":false,"on-select":function (client) { return _vm.$router.push({
          name: 'adminClientAffiliateOverview',
          params: { clientId: client.id }
        }); }}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }